import React from "react"

import intercom from "@irati/utils/intercom"
import {FormattedMessage} from "@irati/utils/lang"
import theme from "@irati/ui/src/global/theme"

import {MarginLeftBody} from "../shared"

const LiveChat = () => {
  const handleClick = () => {
    intercom.show()
  }

  return (
    <MarginLeftBody small marginBottom={1} color={theme.colors.perkbox.blue} onClick={handleClick}>
      <FormattedMessage id="medical.landing.contactCard.liveChat" />
    </MarginLeftBody>
  )
}

export default LiveChat
